import { useEffect, useState, useCallback } from 'react';

interface IUseCountdownReturn {
  timeLeft: number;
  isActive: boolean;
  start: (seconds: number) => void;
  reset: () => void;
  formatTime: (seconds: number) => string;
}

export const useCountdown = (): IUseCountdownReturn => {
  const [timeLeft, setTimeLeft] = useState<number>(0);
  const [isActive, setIsActive] = useState<boolean>(false);

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;

    if (isActive && timeLeft > 0) {
      interval = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            setIsActive(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isActive, timeLeft]);

  const start = useCallback((seconds: number) => {
    setTimeLeft(seconds);
    setIsActive(true);
  }, []);

  const reset = useCallback(() => {
    setTimeLeft(0);
    setIsActive(false);
  }, []);

  const formatTime = useCallback((seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  }, []);

  return {
    timeLeft,
    isActive,
    start,
    reset,
    formatTime,
  };
};
